import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.object.keys.js";
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import useGoogleMaps from './useGoogleMaps';
export default function useSearchMap() {
  var _useGoogleMaps = useGoogleMaps(),
    loader = _useGoogleMaps.loader;
  var store = useNuxtApp().nuxt2Context.store;

  // @ts-ignore
  var tenant = store.state.tenant.tenant;
  var map = ref();
  var marker = ref();
  var circle = ref();
  var cluster = ref({});
  var resultMarkers = ref({});
  var position = ref();
  var radius = ref();
  var polygon = ref();

  // @ts-ignore
  var buildMap = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(element, configuration) {
      var google, coordinates, bounds;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return loader.load();
          case 2:
            google = _context.sent;
            // @ts-ignore
            coordinates = tenant.boundary.features[0].geometry.geometries[0].coordinates[0].map(
            // @ts-ignore
            function (point) {
              return {
                lng: point[0],
                lat: point[1]
              };
            });
            polygon.value = new google.maps.Polygon({
              paths: coordinates
            });
            if (!position.value) {
              bounds = new google.maps.LatLngBounds(); // @ts-ignore
              polygon.value.getPath().forEach(function (element) {
                return bounds.extend(element);
              });
              position.value = {
                lat: bounds.getCenter().lat(),
                lng: bounds.getCenter().lng()
              };
            }
            map.value = new google.maps.Map(element, _objectSpread({
              center: position.value
            }, configuration));
            makeCluster();
            return _context.abrupt("return", map);
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function buildMap(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var makeUi = function makeUi() {
    makeBoundary();
    makeMarker();
    makeCircle();
  };
  var makeBoundary = function makeBoundary() {
    map.value.data.addGeoJson(tenant.boundary);
  };
  var makeMarker = function makeMarker() {
    // @ts-ignore
    marker.value = new google.maps.Marker({
      position: position.value,
      draggable: true,
      zIndex: 100
    });
    marker.value.setMap(map.value);
    watch(position, function (value) {
      marker.value.setPosition(value);
    }, {
      immediate: true
    });

    // @ts-ignore
    marker.value.addListener('drag', function (event) {
      // @ts-ignore
      if (!google.maps.geometry.poly.containsLocation(event.latLng, polygon.value)) {
        marker.value.setPosition(position.value);
        return;
      }
      position.value = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng()
      };
    });

    // @ts-ignore
    marker.value.addListener('dragend', function (event) {
      // @ts-ignore
      if (!google.maps.geometry.poly.containsLocation(event.latLng, polygon.value)) {
        marker.value.setPosition(position.value);
      }
    });
  };
  var makeCircle = function makeCircle() {
    // @ts-ignore
    circle.value = new google.maps.Circle({
      strokeColor: '#ff0000',
      radius: radius.value,
      zIndex: 100
    });
    circle.value.setMap(map.value);
    circle.value.bindTo('center', marker.value, 'position');
    watch(radius, function (value) {
      circle.value.setRadius(value);
    });
  };
  var makeCluster = function makeCluster() {
    cluster.value = new MarkerClusterer({
      map: map.value,
      markers: Object.values(resultMarkers.value)
    });
  };

  // @ts-ignore
  var addResultMarker = function addResultMarker(id, position) {
    // @ts-ignore
    var marker = new google.maps.Marker({
      position: position,
      zIndex: 1,
      icon: {
        anchor: {
          x: 20,
          y: 20
        },
        url: require('~/assets/map/marker.svg')
      }
    });
    marker.setMap(map.value);
    // @ts-ignore
    cluster.value.addMarker(marker);

    // @ts-ignore
    resultMarkers.value[id] = marker;
  };

  // @ts-ignore
  var removeResultMarker = function removeResultMarker(id) {
    // @ts-ignore
    var marker = resultMarkers.value[id];
    marker.setMap(null);

    // @ts-ignore
    cluster.value.removeMarker(marker);
    // @ts-ignore
    delete resultMarkers.value[id];
  };
  var resetResultMarkers = function resetResultMarkers() {
    Object.keys(resultMarkers.value).forEach(function (key) {
      removeResultMarker(key);
    });
  };
  return {
    position: position,
    radius: radius,
    map: map,
    buildMap: buildMap,
    makeUi: makeUi,
    addResultMarker: addResultMarker,
    removeResultMarker: removeResultMarker,
    resetResultMarkers: resetResultMarkers
  };
}